import * as userAction from "../actions/didyoumean.action";
const user = (
  state = {
    status: null,
    loading: false,
    error: null,
    locations: null
  },
  action
) => {
  switch (action.type) {
    case userAction.DID_YOU_MEAN_REQUEST:
      return Object.assign({}, state, {
        status: action.status,
        loading: true
      });
    case userAction.DID_YOU_MEAN_SUCCESS:
      return Object.assign({}, state, {
        locations: action.locations,
        status: action.status,
        loading: false
      });
    case userAction.DID_YOU_MEAN_FAILURE:
      return Object.assign({}, state, {
        error: action.error
      });
    default:
      return state;
  }
};
export default user;
